import { AlertCircle, Clock3 } from "lucide-react";
import { useCountdown } from "../../hooks/useCountdown";

/**
 * Inline countdown badge for an archived restaurant card.
 * Switches style based on urgency: neutral amber → red when <7d → pulsing red <24h.
 */
export default function ArchivedCountdown({ deleteAt, restaurantId }) {
  const { text, critical, urgent, expired } = useCountdown(deleteAt);

  if (!deleteAt) return null;

  const base = "inline-flex items-center gap-1 text-xs font-medium";
  const cls = expired
    ? "text-red-700"
    : urgent
      ? "text-red-700 animate-pulse"
      : critical
        ? "text-red-700"
        : "text-amber-700";

  const Icon = critical ? AlertCircle : Clock3;

  return (
    <span
      className={`${base} ${cls}`}
      data-testid={restaurantId ? `archived-countdown-${restaurantId}` : "archived-countdown"}
      title={`Se elimina el ${new Date(deleteAt).toLocaleString("es-ES")}`}
    >
      <Icon className="h-3 w-3" />
      {expired ? "Borrándose ahora…" : `Quedan ${text}`}
    </span>
  );
}
